
import React from 'react';
import { Separator } from '@/components/ui/separator';
import SelectedGoPlanCard from '@/components/business/onboarding/steps/components/SelectedGoPlanCard';
import GoCampaignStatusCard from '@/components/business/onboarding/steps/components/GoCampaignStatusCard';
import { NavBarBusinessSelector } from '../NavBarBusinessSelector';
import { Business } from '@/schemas/business'; // Changed to Zod-inferred type

interface BusinessPageSectionProps {
  businessName?: string;
  allBusinesses: Business[];
  handleNavigation: (id: string) => void;
  isGoCampaignPage?: boolean;
  isEditPage?: boolean;
  handleEditGoPlan?: () => void;
  handleEditGoCampaign?: () => void;
}

export const BusinessPageSection: React.FC<BusinessPageSectionProps> = ({
  businessName,
  allBusinesses,
  handleNavigation,
  isGoCampaignPage = false,
  isEditPage = false,
  handleEditGoPlan,
  handleEditGoCampaign
}) => {
  // Find by name or displayName, as Zod type has both. Prioritize name if businessName is used for matching.
  const currentBusiness = allBusinesses.find(b => b.name === businessName || b.displayName === businessName); 
  
  return (
    <>
      <Separator 
        orientation="vertical" 
        className="h-8 bg-gray-300 mx-2" 
      />
      
      <NavBarBusinessSelector
        businessName={businessName}
        allBusinesses={allBusinesses}
        onBusinessSelect={handleNavigation}
      />
      
      {isGoCampaignPage && !isEditPage && (
        <>
          <Separator 
            orientation="vertical" 
            className="h-8 bg-gray-300 mx-2" 
          />
          <div className="flex items-center gap-2">
            <SelectedGoPlanCard className="shadow-none border-none" />
            <Separator 
              orientation="vertical" 
              className="h-8 bg-gray-300 ml-2" 
            />
            <GoCampaignStatusCard 
              status={currentBusiness?.status || 'onboarding'} 
              updatedAt={currentBusiness?.updatedAt}
              className="shadow-none border-none"
            />
          </div>
        </>
      )}
    </>
  );
};
